import { Trans } from "@lingui/react/macro";
import React from "react";
import { useLocation } from "react-router";
import { EnvironmentContext } from "../themes/environment";

const Link = ({ href, children }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    {children}
  </a>
);

export const Attributions = () => {
  // Hidden on the shop/checkout flow, where it read as stray clutter
  // (review #46). OpenWeather attribution is a license requirement on every
  // screen showing weather data; fullscreen/embedded charts carry their own
  // copy via Highcharts credits (createOptions.jsx).
  const { pathname } = useLocation();
  if (pathname.startsWith("/shop") || pathname.startsWith("/shared")) {
    return null;
  }
  return (
    <EnvironmentContext.Consumer>
      {({ appName, landingPage }) => (
        <footer className="app-footer p-4 text-center text-xs">
          <p>
            <Trans id="footer.attribution">
              Powered by <Link href={landingPage}>{appName}</Link> · Wetterdaten
              von <Link href="https://openweathermap.org/">OpenWeather</Link>
            </Trans>
          </p>
        </footer>
      )}
    </EnvironmentContext.Consumer>
  );
};
